import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=65c6f1da&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "../style.scss?vue&type=style&index=0&id=65c6f1da&prod&lang=scss&scoped=true&external"
import style1 from "./detail.vue?vue&type=style&index=1&id=65c6f1da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c6f1da",
  null
  
)

export default component.exports